import { useNavigate } from "react-router-dom";

export default function NavButtons() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col sm:flex-row gap-4 w-full">
      <button
        onClick={() => navigate("/team-report")}
        className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-xl"
      >
        📊 Team Report
      </button>
      <button
        onClick={() => navigate("/individual-profiles")}
        className="flex-1 px-4 py-2 bg-green-500 text-white rounded-xl"
      >
        🔍 Individual Profiles
      </button>
      <button
        onClick={() => navigate("/add-result")}
        className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-xl"
      >
        ➕ Add New Result
      </button>
      <button
        onClick={() => navigate("/add-ajss-ranking")}
        className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-xl"
      >
        🏆 Add AJSS Ranking
      </button>
    </div>
  );
}
